// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/overlay/index.css
// module id = 53
// module chunks = 32